import { createSlice } from "@reduxjs/toolkit";

const candidateSlice = createSlice({
  name: "candidateSlice",
  initialState: {
    isLoading: false,
    candidateList: [],
    selectedCandidateIds: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
  },
  reducers: {
    getCandidateListRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getCandidateListSuccess: {
      reducer: (state, action) => {
        console.log(action.payload, "action.payload");
        return {
          ...state,
          isLoading: false,
          candidateList: action.payload?.docs || [],
          pagination: {
            page: action.payload.page || 1,
            limit: action.payload.limit || 10,
            total: action.payload.totalDocs || 0,
          },
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createCandidateRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createCandidateSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    setSelectedCandidateIds(state, action) {
      return {
        ...state,
        selectedCandidateIds: action.payload,
      };
    },
    stopLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    deleteCandidateRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteCandidateSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateCandidateRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateCandidateSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getCandidateDetailRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getCandidateDetailSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        candidateDetail: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
  },
});

export const {
  getCandidateListRequest,
  getCandidateListSuccess,
  createCandidateRequest,
  createCandidateSuccess,
  setSelectedCandidateIds,
  stopLoading,
  deleteCandidateRequest,
  deleteCandidateSuccess,
  updateCandidateRequest,
  updateCandidateSuccess,
  getCandidateDetailRequest,
  getCandidateDetailSuccess,
} = candidateSlice.actions;

export default candidateSlice.reducer;
